import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import Error from '../pages/Error'
import Forbidden from '../pages/Forbidden'
import NotFound from '../pages/NotFound'
import UnSupported from '../components/common/UnSupported'

// sketch order
import Top from '../pages/Top'
import UploadConfirm from '../pages/UploadConfirm'
import UploadComplete from '../pages/UploadComplete'
import ProposeList from '../pages/ProposeList'
import Cart from '../pages/Cart'
import OrderInput from '../pages/OrderInput'
import Planning from '../pages/Planning'
// import Guide from '../sketch/pages/Guide'
// import Support from '../sketch/pages/support'
// import UseRule from '../sketch/pages/UseRule'
// import PrivacyPolicy from '../sketch/pages/PrivacyPolicy'

import {API_URL, APP_NAME, DC_APP_NAME, PTN_DC, PTN_SO, KG_APP_NAME, PTN_KG, PTN_KG_SHEET} from '../constants/App'
import * as Api from '../utils/Api'
import * as AppUtil from '../utils/App'
import * as Check from '../utils/Check'
import {LICENSE_TYPE} from '../constants/Type'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
      meta: {
        title: 'オーダー家具・壁面収納ならスケッチオーダー'
      }
    },
    {
      path: '/uploadConfirm',
      name: 'UploadConfirm',
      component: UploadConfirm,
      meta: {
        title: 'スケッチアップロード確認'
      },
      props: true
    },
    {
      path: '/uploadComplete',
      name: 'UploadComplete',
      component: UploadComplete,
      meta: {
        title: 'スケッチアップロード完了'
      }
    },
    {
      path: '/propose-list',
      name: 'ProposeList',
      component: ProposeList,
      meta: {
        title: 'プラン提案一覧'
      }
    },
    // {
    //   path: '/guide',
    //   name: 'Guide',
    //   component: Guide,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/support',
    //   name: 'Support',
    //   component: Support,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/userule',
    //   name: 'UseRule',
    //   component: UseRule,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/privacypolicy',
    //   name: 'PrivacyPolicy',
    //   component: PrivacyPolicy,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/tokutei',
    //   name: 'Tokutei',
    //   component: Tokutei,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/corpinfo',
    //   name: 'CorpInfo',
    //   component: CorpInfo,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/faq',
    //   name: 'Faq',
    //   component: Faq,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/user/register',
    //   name: 'UserRegister',
    //   component: UserRegister,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/user/update',
    //   name: 'UserUpdate',
    //   component: UserUpdate,
    //   meta: {
    //   }
    // },
    // {
    //   path: '/user/information',
    //   name: 'UserInformation',
    //   component: UserInformation,
    //   meta: {
    //   }
    // },
    {
      path: '/planning',
      name: 'Planning',
      component: Planning,
      meta: {
        title: 'プランニング'
      }
    },
    {
      path: '/order-input',
      name: 'OrderInput',
      component: OrderInput,
      meta: {
        title: '納品先入力'
      }
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: 'カート'
      }
    },
    // 共通
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {}
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {}
    },
    {
      path: '/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    // 必ず最後に定義
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {}
    }
  ],
  scrollBehavior (to, from, savePosiotn) {
    return {x: 0, y: 0}
  }
})

// axiosのキャッシュ設定
axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {}
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
      config.params.append('_', Date.now())
    } else {
      config.params._ = Date.now()
    }
  }

  return config
})

/** タイトル設定 */
const setTitle = function (to) {
  let component = to.matched.find(e => e.meta.title)
  let url = location.href
  if (PTN_KG.test(url)) {
    document.title = component ? component.meta.title + ' | ' + KG_APP_NAME : KG_APP_NAME
  } else if (PTN_DC.test(url)) {
    document.title = component ? component.meta.title + ' | ' + DC_APP_NAME : DC_APP_NAME
  } else {
    document.title = component ? component.meta.title : APP_NAME
  }
}

/** Intercomのメッセンジャーの表示 */
const dispMessenger = function (to) {
  window.Intercom('shutdown')
  if (to.matched.some(e => e.meta.requireMessenger)) {
    window.Intercom('boot', {
      app_id: 'vpld6oei',
      vertical_padding: 1,
      horizontal_padding: 23
    })
  }
}

/** ズームイン・ズームアウトの可否を設定 */
const setUserScaleNo = function () {
  let url = location.href
  let userNoScale = 'user-scalable=no'
  let viewport = document.querySelector('meta[name="viewport"]')
  let viewportContent = viewport.getAttribute('content')
  if (PTN_KG.test(url) && !PTN_KG_SHEET.test(url)) {
    // ズームイン・ズームアウトが不可に設定されていなかったら不可に設定する
    if (!viewportContent.match(userNoScale)) {
      viewport.setAttribute('content', viewportContent + ', ' + userNoScale)
    }
  } else {
    // ズームイン・ズームアウトが不可に設定されていたら可能に設定する
    if (viewportContent.match(userNoScale)) {
      let replaceViewportContent = viewportContent.replace(userNoScale, '').replace(/, $/, '')
      viewport.setAttribute('content', replaceViewportContent)
    }
  }
}

// 画面初期表示時にサーバーアクセスがないものについては、vue-routerの機能を利用して画面描画開始前に認証処理を行う。
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('unsupported') === -1) {
    let url = location.href
    if (PTN_DC.test(url) || PTN_SO.test(url)) {
      if (!Check.brawserCheck()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/mmstyle/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    } else if (!PTN_KG.test(url)) {
      if (!Check.brawserCheckForDaros()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    }
  }

  // 画面初期表示時、認証チェック
  if (to.matched.some(e => e.meta.requiresAuth)) {
    axios.get(API_URL.INIT, {
      params: {
        pageUrl: to.path
      }
    }).then(response => {
      // お試しユーザーに許容していない画面はプランニング画面に遷移させる
      if (to.matched.some(e => e.meta.notPermitTrial) && AppUtil.getUserInfo().licenseType === LICENSE_TYPE.TRIAL) {
        router.push('/planning')
      } else {
        setTitle(to)
        next()
        dispMessenger(to)
        setUserScaleNo()
      }
    }).catch(error => {
      Api.handleError(error)
    })
    return
  }
  setTitle(to)
  next()
  dispMessenger(to)
  setUserScaleNo()
})

export default router



// WEBPACK FOOTER //
// ./src/main/js/router/index.js